import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const DAILY_UPDATES_QUERY_KEY = ['dailyUpdates'];

export function useDailyUpdates({ meta }: { meta?: LevStandardQueryMeta }) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IDashboardUpdates>('dashboard/dailyUpdates', 'GET');
		},
		queryKey: DAILY_UPDATES_QUERY_KEY,
		meta,
	});
}

export const invalidateDailyUpdates = () => reactQueryClient.invalidateQueries({ queryKey: DAILY_UPDATES_QUERY_KEY });
